// Agreement Template Service
// This service generates the Agreement of Sale HTML template with dynamic data

import {
  getCurrencyRates,
  convertToBaseCurrency,
  formatData,
} from "./BackendServices";
import config from "../aws-exports";
export const generateAgreementTemplate = (offerData) => {
  // Currency conversion constants and function
  const bucket = process.env.REACT_APP_AMTPL_BUCKET;
  let bucketfolder = "public/images";
  const filePath = `${bucketfolder}/`;
  const fileUrl = `https://${bucket}.s3.${config.aws_project_region}.amazonaws.com/${filePath}logo.png`;

  const {
    // Buyer Information
    buyerName = "[Buyer Name]",
    buyerAddress = "[Buyer Address]",
    buyerContact = "[Buyer Contact Details]",

    // Product Information
    productName = "[Product Name]",
    quantity = "[Quantity]",
    hsnCode = "[HSN Code]",
    variety = "[Variety]",
    grade = "[Grade]",
    specification = "[Specification]",
    packaging = "[Packaging]",
    bagStrength = "[Bag Strength]",

    // Price & Delivery
    fobSalePrice = "[FOB Sale Price]",
    cifPrice = "[CIF Price]",
    exportDuties = "[Export Duties]",
    totalValue = "[Total Value]",
    currency = "USD",
    incoterm = "[Incoterm]",
    loadingPort = "[Loading Port]",
    dischargePort = "[Discharge Port]",
    shipmentType = "[Shipment Type]",
    deliveryPeriod = "[Delivery Period]",

    // Payment Terms
    paymentMethod = "[Payment Method]",
    paymentTimeline = "[Payment Timeline]",
    partialDelivery = "[Partial Delivery]",

    // Agreement Details
    agreementDate = new Date().toLocaleDateString(),
    validityDays = "[Validity Days]",
  } = offerData;

  return `
<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Agreement of Sale</title>
    <style>
        body {
            font-family: 'Arial', sans-serif;
            font-size: 12pt;
            line-height: 1.5;
            margin: 0;
            padding: 0;
            background-color: #ffffff;
        }
        .container {
            width: 100%;
            max-width: 800px;
            margin: 20px auto;
            padding: 20px;
            background-color: #ffffff;
            border: 1px solid #ddd;
            border-radius: 5px;
        }
        h1 {
            text-align: center;
            font-size: 16pt;
            font-weight: bold;
            color: #333;
            margin-bottom: 20px;
            text-transform: uppercase;
        }
        .section {
            margin-bottom: 20px;
        }
        .section h2 {
            font-size: 14pt;
            font-weight: bold;
            color: #333;
            border-bottom: 2px solid #de6b14;
            padding-bottom: 5px;
            margin-bottom: 10px;
        }
        .terms-table {
            width: 100%;
            border-collapse: collapse;
           
			border:none
        }
		
        .terms-table td {
            padding: 10px;
            
        }
        .terms-table .detail {
            font-weight: bold;
            width: 25%;
            
        }
        .terms-table .term {
            width: 75%;
        }
        p {
            margin: 10px 0;
            color: #555;
        }
        .party-info {
            margin: 15px 0;
            
            padding: 10px;
            border-radius: 3px;
        }
        .signature {
            margin-top: 40px;
            display: flex;
            justify-content: space-between;
            border-top: 1px solid #ddd;
            padding-top: 20px;
        }
        .signature div {
            text-align: center;
        }
        .signature p {
            margin: 5px 0;
            color: #333;
        }
        .signature-line {
            border-bottom: 1px solid #000;
            width: 150px;
            margin: 10px auto;
        }
		.signatures-wrapper {
           
            color: #696666;
            border-radius: 8px;
            overflow: hidden;
          
        }
       
       
        .party-header {
            font-weight: bold;
            font-size: 14pt;
            margin-bottom: 20px;
            padding-bottom: 8px;
            border-bottom: 1px solid #55555529;
			color: #000;
        }
        .field-row {
           
            margin-bottom: 16px;
            font-size: 12pt;
        }
        .field-label {
            font-weight: normal;
            min-width: 100px;
        }
        .field-value {
            border-bottom: 1px dashed #fff;
            width: 100%;
            max-width: 220px;
            padding: 0 5px;
            text-align: right;
            color: #fff;
        }
        .field-value.filled {
            border-bottom: none;
            font-weight: normal;
        }
        .field-value.date {
            font-style: italic;
        }
		
		
        .signatures-title {
            background-color: #eaeff77d;
            padding: 12px 20px;
            font-size: 16pt;
            font-weight: bold;
            text-align: left;
            text-transform: uppercase;
        }
        .signatures-content {
            
            padding: 25px 10px;
            
        }
        .party-block {
            flex: 1;
        }
        
        
        .field-value.filled {
            border-bottom: none;
            font-weight: normal;
        }
        .field-value.date {
            font-style: italic;
        }
        .logo{
        width:100px
        }
		.print-button {
            position: fixed;
            top: 10px;
            right: 10px;
            padding: 10px 20px;
            background-color: #de6b14 !important;
            color: white;
            border: none;
            border-radius: 5px;
            cursor: pointer;
            font-size: 14px;
            z-index: 1000;
            box-shadow: 0 2px 5px rgba(0,0,0,0.2);
        }
        @media print {
            body {
                background-color: #fff;
            }
            .container {
                box-shadow: none;
                max-width: none;
                width: 100%;
            }
            .print-button {
                display: none !important;
            }
        }
            .logo{
		width: 100px;
		}
		.logo-content{
		position:absolute;
		top:45px;
		}
    </style>
</head>
<body>
    <div class="container">
    <div class="logo-content">
	<img class="logo" src=${fileUrl} alt="logo"/>
	</div>
	<h1>AGREEMENT OF SALE</h1>
        <p>This Agreement of Sale (hereinafter referred to as the "Agreement") is made and entered into on this 13th day of November, 2025 by and between:</p>
        <div class="party-info">
            <p><strong>Seller Details</strong><br/>
            Agropreneurs Market Technologies Pvt. Ltd., a company duly incorporated and existing under the laws of India, having its registered office at 1105, Colonnade2, Bodakdev, Sindhu Bhavan Road, Thaltej, Ahmedabad, Gujarat, India, 380054 (hereinafter referred to as the "Seller").</p>
        </div>
        <div class="party-info">
            <p><strong>Buyer Details</strong><br/>
            <b>Name:</b> ${buyerName}<br/>
            <b>Address:</b> ${buyerAddress}<br/>
            <b>Contact:</b> ${buyerContact}</p>
			<p>The Seller and the Buyer shall hereinafter be referred to individually as a "Party" and collectively as the "Parties".</p>
        </div>
        <div class="party-info">
        <p><strong>RECITALS</strong></p>
        <p>WHEREAS the Seller is engaged in the business of supplying high-quality agricultural commodities, and the Buyer desires to purchase the specified goods under the terms and conditions set forth herein;</p>
        <p>NOW, THEREFORE, in consideration of the mutual covenants and promises contained herein, the Parties hereby agree as follows:</p>
</div>
        

        <div class="section">
            <h2>1. Product Description:</h2>
            <p>The Seller agrees to supply <b>${quantity} Metric Tons (MT)</b> of high-quality <b>${productName}</b> as per the following specifications:</p>
            <table class="terms-table">
			 <tr class="backcolor"><td class="detail">Details</td><td class="Details"><b>Description</b></td></tr>
                <tr><td class="detail">HSN Code</td><td class="term">${hsnCode}</td></tr>
                <tr><td class="detail">Variety</td><td class="term">${variety}</td></tr>
                <tr><td class="detail">Grade</td><td class="term">${grade}</td></tr>
                <tr><td class="detail">Specification</td><td class="term">${specification}</td></tr>
                <tr><td class="detail">Packaging</td><td class="term">${packaging}</td></tr>
                <tr><td class="detail">Bag Strength</td><td class="term">${bagStrength}</td></tr>
            </table>
        </div>

        <div class="section">
            <h2>2. Price & Delivery Terms:</h2>
            <table class="terms-table">
			 <tr class="backcolor"><td class="detail">Details</td><td class="Details"><b>Term</b></td></tr>
                <tr><td class="detail">Total FOB Sale Price</td><td class="term">${formatData(fobSalePrice)} USD</td></tr>
                <tr><td class="detail">Incoterm</td><td class="term">${incoterm}</td></tr>
                <tr><td class="detail">Loading Port</td><td class="term">${loadingPort}</td></tr>
                <tr><td class="detail">Discharge Port</td><td class="term">${dischargePort}</td></tr>
                <tr><td class="detail">Shipment</td><td class="term">${shipmentType}</td></tr>
                <tr><td class="detail">Delivery Period</td><td class="term">${deliveryPeriod}</td></tr>
            </table>
        </div>

        <div class="section">
            <h2>3. Payment Terms:</h2>
            <table class="terms-table">
			 <tr class="backcolor"><td class="detail">Details</td><td class="Details"><b>Term</b></td></tr>
                <tr><td class="detail">Preferred Payment Method</td><td class="term">${paymentMethod}</td></tr>
                <tr><td class="detail">Payment Timeline</td><td class="term">${paymentTimeline}</td></tr>
                <tr><td class="detail">Partial Delivery Allowed</td><td class="term">${partialDelivery}</td></tr>
            </table>
        </div>

        <div class="section">
            <h2>4. Inspection:</h2>
            <p>Quality Inspection Required by an internationally recognized inspection agency (e.g., SGS) at the loading port, costs borne by the Seller.</p>
        </div>

        <div class="section">
            <h2>5. Validity of Agreement:</h2>
            <p>This Agreement is valid and binding from the date of acceptance and shall remain valid for 15 calendar days from the date of issuance, subject to Seller's written confirmation of LC receipt.</p>
        </div>

        <div class="section">
            <h2>6. Governing Law:</h2>
            <p>This Agreement shall be governed by and construed in accordance with applicable International Trade Laws and Practices (INCOTERMS 2020). Any disputes arising shall be settled via arbitration in accordance with the rules of the International Chamber of Commerce (ICC).</p>
        </div>

        <div class="signatures-wrapper">
    <div class="signatures-title">Signatures</div>
    <div class="signatures-content">

        <!-- Seller Block -->
        <div class="party-block">
            <div class="party-header">For Agropreneurs Market Technologies Pvt. Ltd. (The Seller)</div>

            <table class="terms-table">
                <tr>
                    <td class="detail">Signature:</td>
                    <td class="term">______________________</td>
                </tr>
                <tr>
                    <td class="detail">Name:</td>
                    <td class="term">______________________</td>
                </tr>
                <tr>
                    <td class="detail">Designation:</td>
                    <td class="term">______________________</td>
                </tr>
                <tr>
                    <td class="detail">Date:</td>
                    <td class="term filled">______________________</td>
                </tr>
            </table>
        </div>

        <!-- Buyer Block -->
        <div class="party-block">
            <div class="party-header">For Buyer (The Buyer)</div>

            <table class="terms-table">
                <tr>
                    <td class="detail">Signature:</td>
                    <td class="term">______________________</td>
                </tr>
                <tr>
                    <td class="detail">Name:</td>
                    <td class="term filled">______________________</td>
                </tr>
                <tr>
                    <td class="detail">Designation:</td>
                    <td class="term">______________________</td>
                </tr>
                <tr>
                    <td class="detail">Date:</td>
                    <td class="term filled">______________________</td>
                </tr>
            </table>
        </div>

   
</div>

    </div>
</body>
</html>
  `;
};

// Function to open agreement popup with print functionality
export const openAgreementPopup = (offerData) => {
  const agreementHTML = generateAgreementTemplate(offerData);

  // Create a new window for the agreement
  const printWindow = window.open(
    "",
    "_blank",
    "width=800,height=600,scrollbars=yes,resizable=yes"
  );

  if (printWindow) {
    printWindow.document.write(agreementHTML);
    printWindow.document.close();

    // Add print button functionality
    printWindow.onload = function () {
      // Add print button to the document
      const printButton = printWindow.document.createElement("button");
      printButton.innerHTML = "🖨️ Print Agreement";
      printButton.className = "print-button";

      printButton.onclick = function () {
        printWindow.print();
      };

      printWindow.document.body.appendChild(printButton);

      // Focus the window
      printWindow.focus();
    };
  } else {
    alert("Please allow popups to view the agreement");
  }
};

// Function to extract offer data for agreement template
export const extractOfferDataForAgreement = (offer) => {
  return {
    // Buyer Information - these would come from the logged-in user or form data
    buyerName: offer.buyerName || "",
    buyerAddress: offer.buyerAddress || "",
    buyerContact: offer.buyerContact || "",

    // Product Information
    productName: offer.ProductName || offer.productName || "",
    quantity: offer.Quantity || "",
    hsnCode: offer.HsCode || "",
    variety: offer.Variety || "",
    grade: offer.Grade || "",
    specification: offer.productSpecifications || offer.Specification || "",
    packaging: offer.PackagingType || "",
    bagStrength: offer.PackagingSize || "",

    // Price & Delivery
    fobSalePrice: offer.FOBSalePrice || "",
    cifPrice: offer.CIFSalePrice || "",
    exportDuties: offer.ExportDuty || "",
    totalValue: offer.CIFSalePrice || offer.FOBSalePrice || "",
    currency: offer.Currency || "USD",
    incoterm: offer.INCO || "",
    loadingPort: offer.LoadingPort || "",
    dischargePort: offer.DischargePort || "",
    shipmentType:
      offer.ShippingMethodPreference ||
      "Containerized Cargo in 20/40 Ft Containers",
    deliveryPeriod: offer.TransitTime || "",

    // Payment Terms
    paymentMethod: offer.PreferredPaymentMethod || "",
    paymentTimeline: offer.PaymentTerms || "",
    partialDelivery: offer.PartialDeliveryAllowed ? "Yes" : "No",

    // Agreement Details
    agreementDate: new Date().toLocaleDateString(),
    validityDays: "",
  };
};
